import React from 'react'

const WhatsNew = () => {
    
    return (
      <>
      <div>WhatsNew</div>
      <a href='/'>Back to Home</a>
      </>
    )
  }

export default WhatsNew;